import { Component, OnInit } from '@angular/core';
import { AddressService } from '@app/shared/services/address/address.service';
import { CommonService } from '@app/shared/services/common/common.service';
import { ForceChangePasswordComponent } from '@app/auth/force-change-password/force-change-password.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LoginAndSignUpDataComponent, PopupService } from '@app/shared/services/popup/popup.service';
import { Router, ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-storelayout',
  templateUrl: './storelayout.component.html',
  styleUrls: ['./storelayout.component.css']
})
export class StorelayoutComponent implements OnInit {

  public extend = '';
  constructor(private common: CommonService,
    private popupService: PopupService,
    public dialog: MatDialog,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    this.router = router;
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
  }
  currentYear: number = new Date().getFullYear();
  ngOnInit() {
    this.common.subShopifyDesign().subscribe((res: { shopify: boolean }) => {
      res.shopify ? this.extend = 'no-margin' : this.extend = '';
    });

    const a = $(window).height();
    const d = $('.footer').height() + 100;
    const e = a - d;
    $('.content-blk').css('min-height', e);

    if (localStorage.getItem('ForceChangePassword') == 'true') {
      setTimeout(() => this.fn_ForceChangePassword());
    }
  }
  ngAfterViewInit() {
  }

  fn_ForceChangePassword() {
    if (location.href.toLowerCase().indexOf("adminaccount") == -1) {
      this.router.navigate(['/store/adminaccount']);
    }
  }

  fn_OnResize(event: any) {
    const a = $(window).height();
    const d = $('.footer').height() + 100;
    const e = a - d;
    $('.content-blk').css('min-height', e);
  }


}
